import api from './api';
import type { SnapshotData, GraphPoint, BreakdownRow, DailyReport } from '../types';

export async function getSummary(from: string, to: string): Promise<SnapshotData> {
  const { data } = await api.get('/partner/stats/summary', { params: { from, to } });
  return data.data;
}

export async function getGraph(from: string, to: string): Promise<GraphPoint[]> {
  const { data } = await api.get('/partner/stats/graph', { params: { from, to } });
  return data.data;
}

const GROUP_BY_MAP: Record<string, string> = { channel: 'flow_id', offer: 'offer_id', country: 'country' };

export async function getBreakdown(from: string, to: string, groupBy: string): Promise<BreakdownRow[]> {
  const { data } = await api.get('/partner/stats/breakdown', { params: { from, to, group_by: GROUP_BY_MAP[groupBy] || groupBy } });
  return data.data;
}

export async function getReports(from: string, to: string, groupBy?: string): Promise<DailyReport[]> {
  const params: Record<string, string> = { from, to };
  if (groupBy) params.group_by = groupBy;
  const { data } = await api.get('/partner/reports', { params });
  return data.data;
}
